import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Typography } from '@mui/material';
import LinkButton from '../../../../components/Buttons/LinkButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Theme from '../../../../Themes/main.theme';
import { DefaultTFuncReturn } from 'i18next';
import { useTranslation } from 'react-i18next';
import UserService from '../../../../services/UserService';
import { FromScratcFormFormType } from '../../../../components/dictionaries/Request';
//import { useTranslation } from 'react-i18next';

interface SingleAccordionProps {
  title: string;
  description: string;
  linkUrl: string;
  linkTitle: string
  formTypeId: number,

}
interface SimpleAccordionProps {
  title?: string | DefaultTFuncReturn
  children?: any;
  accordions?: SingleAccordionProps[];
  linkUrl?: string;
  redirectsOutsideShadow?: boolean;
  linkTitle?: string;

}

export function SimpleAccordion(props: SimpleAccordionProps) {
  const { title, accordions = [], redirectsOutsideShadow = false } = props;
  const { t } = useTranslation();

  return (
  
    <Box
      mb={3}
      display='flex' 
      flexDirection='column'
      gap={2}>
      <Box display='flex'>
        <Divider variant='middle' 
          sx={{ border: 1, color: Theme?.dividerColor?.main}} />
        <Typography
          variant='h3'>
          {title} 
        </Typography>
      </Box>
      <Box
        display='flex'
        flexDirection='column'
        gap={1}>
        {accordions.map((accordion: SingleAccordionProps) => {
          const { linkTitle = t('Μετάβαση στην αίτηση') as string } = props;

          return <Accordion key={accordion.title} sx={{ backgroundColor: 'transparent' }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls='panel1a-content'
              id='panel1a-header'
            >
              <Typography 
                variant='h4'
                sx={{ marginLeft: '10px', width: '80%', flexShrink: 0, fontWeight: 'medium' }}>
                {accordion.title}
              </Typography>

            </AccordionSummary>
            <AccordionDetails>
              <Divider sx={{ mb: 2 }}/>
              <Box 
                display='flex'
                justifyContent='space-between'
                alignContent='center'
                mx={1} 
              >
                <Typography alignSelf='center'>
                  {accordion.description}
                </Typography>
                <LinkButton
                  renderOutsideReactRouter={redirectsOutsideShadow}
                  variant='contained'
                  disabled={!(UserService.isAuthenticated()
                     || accordion.formTypeId == FromScratcFormFormType.AnonyumousForm)}
                  color='primary'
                  link={`${accordion.linkUrl}`}>
                  {linkTitle}
                </LinkButton>
                
              </Box>
            </AccordionDetails>
          </Accordion>;

        })}
      </Box>

    </Box>
  );
}
